<div
  class="bm-event-card"
  (click)="showEventDetails()"
  [ngClass]="{
    'for-standalone': !fromEventList,
    'for-your-tickets': forTicketList,
    disabled: event.isExpired || event.isDeleted
  }"
  [ngStyle]="{ width: itemWidth + 'px' }"
>
  <a
    *ngIf="eventHref as href"
    class="bm-event-card__link"
    [attr.href]="href"
    (click)="onEventLinkClick($event)"
  >
    <span class="cdk-visually-hidden">View {{ event.title }}</span>
  </a>
  <!--      'for-popup': forPopup,
      'for-beacon': forBeaconPage,
      'for-ticket-list': forTicketList,-->
  <div class="info-container">
    <div
      class="image"
      [ngStyle]="{
        background:
          'url(' +
          (event?.image?.length || (event.image && !isBrowser)
            ? event.image
                .replace('original', 'thumbnail_1200x600')
                .replace('.png', '.jpg')
            : '/assets/img/no-photo.svg') +
          ') no-repeat center',
        'background-size': 'cover'
      }"
      [ngClass]="{
        pulse: !isBrowser,
        passport: isPassportMode
      }"
    ></div>
    <div class="about-container" [@contentIn] [class.passport]="isPassportMode">
      <div class="title" *ngIf="event" [class.pulse]="!isBrowser">
        <span> {{ event.title }}</span>
        <svg
          *ngIf="forTicketList && !(event.isExpired || event.isDeleted)"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.89362 7.78723C6.40009 7.78723 6 7.38715 6 6.89362C6 6.40009 6.40009 6 6.89362 6H17.1064C17.5999 6 18 6.40009 18 6.89362V17.1064C18 17.5999 17.5999 18 17.1064 18C16.6129 18 16.2128 17.5999 16.2128 17.1064V9.051L7.5255 17.7383C7.17652 18.0872 6.61071 18.0872 6.26173 17.7383C5.91276 17.3893 5.91276 16.8235 6.26173 16.4745L14.949 7.78723H6.89362Z"
            fill="#697586"
          />
        </svg>
      </div>

      <ng-container *ngIf="fromEventList">
        <span class="date">
          <mat-icon svgIcon="custom:events"></mat-icon>
          <span [class.pulse]="!isBrowser">
            Starts at
            {{
              event.start
                | date : (event.noStartTime ? 'MMM dd ' : 'MMM dd, h:mm a')
            }}
          </span>
        </span>
        <div class="description" [id]="'description' + event.id">
          <ng-container
            *ngIf="
              places?.length === 0 &&
                (event.onlineEventLink || event.onlineEventDetails);
              else locationSvg
            "
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.295 29.9649L39.5999 28.1602L20.1523 20.1526L28.1599 39.6002L30.0076 32.2953L35.4627 37.7504C35.7703 38.0581 36.255 38.0581 36.518 37.7504L37.7503 36.5181C38.058 36.2104 38.058 35.7257 37.7503 35.4628L32.295 29.9649Z"
                fill="black"
              />
              <path
                d="M24.0248 33.4849C24.1572 33.3096 24.2895 33.1325 24.3772 32.9572L23.4525 30.7125C22.4401 32.8249 21.2078 34.0572 20.1525 34.0572C19.0525 34.0572 17.7772 32.7372 16.7648 30.5372C16.2801 29.5249 15.8848 28.3819 15.6201 27.1049C17.0725 27.3249 18.6125 27.4125 20.1952 27.4125C20.8552 27.4125 21.5152 27.4125 22.1305 27.3679L21.3829 25.5202H20.1952C18.4799 25.5202 16.8076 25.3879 15.2228 25.1249C14.9581 23.5402 14.8275 21.8696 14.8275 20.1525C14.8275 18.4372 14.9598 16.7648 15.2228 15.18C16.8075 14.9153 18.4781 14.7847 20.1952 14.7847C21.9105 14.7847 23.5829 14.917 25.1677 15.18C25.4324 16.7647 25.563 18.4353 25.563 20.1525V21.2972L27.4106 22.0448C27.4553 21.4295 27.4553 20.7695 27.4553 20.1095C27.4553 18.5248 27.3677 16.9848 27.1477 15.5344C28.38 15.8421 29.523 16.2391 30.58 16.6791C32.78 17.6915 34.1 18.9667 34.1 20.0667C34.1 21.1667 32.8677 22.3991 30.8 23.3667L33.0447 24.2915C33.22 24.1591 33.3971 24.0715 33.5724 23.9391C33.5277 24.1144 33.4847 24.2915 33.3971 24.4238L35.1571 25.1285C35.6847 23.5438 35.9923 21.8285 35.9923 20.0236C35.9047 11.4401 28.8648 4.40012 20.1523 4.40012C11.4399 4.40012 4.3999 11.4401 4.3999 20.1526C4.3999 28.865 11.4399 35.905 20.1523 35.905C21.957 35.905 23.6723 35.5973 25.2572 35.0697L24.5525 33.3097C24.3755 33.3527 24.2002 33.3956 24.0249 33.485L24.0248 33.4849ZM29.9648 10.34C31.6372 12.0124 32.8248 14.0353 33.4848 16.28C31.8572 15.0924 29.5248 14.1677 26.7524 13.5524C26.18 10.78 25.2124 8.44748 24.0247 6.81992C26.2247 7.47992 28.2477 8.66757 29.9647 10.3399L29.9648 10.34ZM20.1524 6.29236C21.2524 6.29236 22.5277 7.61236 23.54 9.81236C24.0247 10.8247 24.42 11.9677 24.6847 13.2447C23.2324 13.0247 21.6924 12.9371 20.1096 12.9371C18.5249 12.9371 16.9849 13.0247 15.5345 13.2447C15.8421 12.0124 16.2392 10.8694 16.6792 9.81236C17.7328 7.61236 19.0081 6.29236 20.1528 6.29236H20.1524ZM10.3399 10.34C12.0123 8.66766 14.0352 7.48001 16.2799 6.82001C15.0923 8.44766 14.1676 10.78 13.5523 13.5525C10.7799 14.1248 8.44741 15.0925 6.81985 16.2801C7.47985 14.0801 8.6675 12.0554 10.3399 10.3401L10.3399 10.34ZM9.81229 16.7649C10.8246 16.2802 11.9676 15.8849 13.2446 15.6202C13.0246 17.0725 12.937 18.6125 12.937 20.1953C12.937 21.78 13.0246 23.32 13.2446 24.7704C12.0123 24.4628 10.8693 24.0657 9.81229 23.6257C7.61229 22.6134 6.29229 21.3381 6.29229 20.2381C6.29229 19.1398 7.61229 17.7751 9.81229 16.7645V16.7649ZM10.3399 29.9649C8.66759 28.2925 7.47994 26.2696 6.81994 24.0249C8.44759 25.2125 10.7799 26.1372 13.5524 26.7525C14.1247 29.5249 15.0924 31.8574 16.28 33.485C14.08 32.825 12.0124 31.6356 10.34 29.965L10.3399 29.9649Z"
                fill="black"
              />
            </svg>
          </ng-container>

          <ng-template #locationSvg>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.9987 3.18166C8.6235 3.18166 7.30463 3.74037 6.33222 4.73488C5.35981 5.72939 4.81351 7.07824 4.81351 8.48469C4.81351 10.4581 6.12497 12.5465 7.58937 14.2314C8.3042 15.0538 9.02132 15.7417 9.56055 16.2242C9.7255 16.3718 9.87331 16.4998 9.9987 16.606C10.1241 16.4998 10.2719 16.3718 10.4368 16.2242C10.9761 15.7417 11.6932 15.0538 12.408 14.2314C13.8724 12.5465 15.1839 10.4581 15.1839 8.48469C15.1839 7.07824 14.6376 5.72939 13.6652 4.73488C12.6928 3.74037 11.3739 3.18166 9.9987 3.18166ZM9.9987 17.5756C9.55425 18.1817 9.55409 18.1815 9.55391 18.1814L9.55343 18.181L9.55206 18.18L9.54771 18.1766L9.53271 18.165C9.51994 18.155 9.50172 18.1407 9.47839 18.1222C9.43174 18.0853 9.36467 18.0315 9.28008 17.9619C9.11096 17.823 8.87146 17.6208 8.58499 17.3645C8.01311 16.8527 7.24876 16.1201 6.4821 15.238C4.98353 13.5138 3.33203 11.0567 3.33203 8.48469C3.33203 6.67639 4.03441 4.94216 5.28465 3.6635C6.5349 2.38485 8.23059 1.6665 9.9987 1.6665C11.7668 1.6665 13.4625 2.38485 14.7127 3.6635C15.963 4.94216 16.6654 6.67639 16.6654 8.48469C16.6654 11.0567 15.0139 13.5138 13.5153 15.238C12.7486 16.1201 11.9843 16.8527 11.4124 17.3645C11.1259 17.6208 10.8864 17.823 10.7173 17.9619C10.6327 18.0315 10.5657 18.0853 10.519 18.1222C10.4957 18.1407 10.4775 18.155 10.4647 18.165L10.4497 18.1766L10.4453 18.18L10.444 18.181L10.4435 18.1814C10.4433 18.1815 10.4431 18.1817 9.9987 17.5756ZM9.9987 17.5756L10.4431 18.1817C10.1798 18.3837 9.81763 18.3837 9.55425 18.1817L9.9987 17.5756ZM9.9987 6.96953C9.1805 6.96953 8.51722 7.64789 8.51722 8.48469C8.51722 9.32148 9.1805 9.99984 9.9987 9.99984C10.8169 9.99984 11.4802 9.32148 11.4802 8.48469C11.4802 7.64789 10.8169 6.96953 9.9987 6.96953ZM7.03574 8.48469C7.03574 6.8111 8.3623 5.45438 9.9987 5.45438C11.6351 5.45438 12.9617 6.8111 12.9617 8.48469C12.9617 10.1583 11.6351 11.515 9.9987 11.515C8.3623 11.515 7.03574 10.1583 7.03574 8.48469Z"
                fill="#42526E"
              />
            </svg>
          </ng-template>

          <span
            [class.pulse]="!isBrowser"
            class="_places"
            *ngIf="places?.length > 0 || event.locations?.length > 0"
          >
            <ng-container *ngFor="let item of places; let last = last">
              <span *ngIf="item && item.locationInfo">
                {{ item.titleWeb }}<span *ngIf="!last">, </span>
              </span>
            </ng-container>
            <span *ngIf="places?.length && event.locations?.length">, </span>
            <ng-container *ngFor="let item of event.locations; let last = last">
              <span *ngIf="item && item.locationInfo">
                {{ item.name }}<span *ngIf="!last">, </span>
              </span>
            </ng-container>
          </span>
          <ng-container
            *ngIf="
              places?.length === 0 &&
              (event.onlineEventLink || event.onlineEventDetails)
            "
          >
            Online event
          </ng-container>
        </div>

        <div
          *ngIf="isFree || ticketMinPrice"
          class="_price"
          [class.pulse]="!isBrowser"
        >
          <span *ngIf="isFree"> Free </span>
          <ng-container *ngIf="ticketMinPrice !== undefined">
            <span><span *ngIf="isFree"> & </span> From</span>
            <span *ngIf="ticketMinPrice !== undefined">
              {{ ticketMinPrice / 100 | currency }}
            </span>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="!fromEventList">
        <div class="_passport-info" *ngIf="isPassportMode; else eventDataCards">
          <div class="_data-card sm">
            <div class="_data-card__logo grey">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.9987 3.18166C8.6235 3.18166 7.30463 3.74037 6.33222 4.73488C5.35981 5.72939 4.81351 7.07824 4.81351 8.48469C4.81351 10.4581 6.12497 12.5465 7.58937 14.2314C8.3042 15.0538 9.02132 15.7417 9.56055 16.2242C9.7255 16.3718 9.87331 16.4998 9.9987 16.606C10.1241 16.4998 10.2719 16.3718 10.4368 16.2242C10.9761 15.7417 11.6932 15.0538 12.408 14.2314C13.8724 12.5465 15.1839 10.4581 15.1839 8.48469C15.1839 7.07824 14.6376 5.72939 13.6652 4.73488C12.6928 3.74037 11.3739 3.18166 9.9987 3.18166ZM9.9987 17.5756C9.55425 18.1817 9.55409 18.1815 9.55391 18.1814L9.55343 18.181L9.55206 18.18L9.54771 18.1766L9.53271 18.165C9.51994 18.155 9.50172 18.1407 9.47839 18.1222C9.43174 18.0853 9.36467 18.0315 9.28008 17.9619C9.11096 17.823 8.87146 17.6208 8.58499 17.3645C8.01311 16.8527 7.24876 16.1201 6.4821 15.238C4.98353 13.5138 3.33203 11.0567 3.33203 8.48469C3.33203 6.67639 4.03441 4.94216 5.28465 3.6635C6.5349 2.38485 8.23059 1.6665 9.9987 1.6665C11.7668 1.6665 13.4625 2.38485 14.7127 3.6635C15.963 4.94216 16.6654 6.67639 16.6654 8.48469C16.6654 11.0567 15.0139 13.5138 13.5153 15.238C12.7486 16.1201 11.9843 16.8527 11.4124 17.3645C11.1259 17.6208 10.8864 17.823 10.7173 17.9619C10.6327 18.0315 10.5657 18.0853 10.519 18.1222C10.4957 18.1407 10.4775 18.155 10.4647 18.165L10.4497 18.1766L10.4453 18.18L10.444 18.181L10.4435 18.1814C10.4433 18.1815 10.4431 18.1817 9.9987 17.5756ZM9.9987 17.5756L10.4431 18.1817C10.1798 18.3837 9.81763 18.3837 9.55425 18.1817L9.9987 17.5756ZM9.9987 6.96953C9.1805 6.96953 8.51722 7.64789 8.51722 8.48469C8.51722 9.32148 9.1805 9.99984 9.9987 9.99984C10.8169 9.99984 11.4802 9.32148 11.4802 8.48469C11.4802 7.64789 10.8169 6.96953 9.9987 6.96953ZM7.03574 8.48469C7.03574 6.8111 8.3623 5.45438 9.9987 5.45438C11.6351 5.45438 12.9617 6.8111 12.9617 8.48469C12.9617 10.1583 11.6351 11.515 9.9987 11.515C8.3623 11.515 7.03574 10.1583 7.03574 8.48469Z"
                  fill="#42526E"
                />
              </svg>
            </div>
            <div class="_data-card__content" [class.pulse]="!isBrowser">
              <div class="_data-card__content__details">
                <span [translate]="'passport.check-in-label'"></span>
              </div>
              <div class="_data-card__content__title">
                <span
                  [translate]="'passport.check-in-visit'"
                  [translateParams]="{
                    neededCount: passportPlacesToVisitRequiredCount,
                    placesCount: places?.length
                  }"
                ></span>
              </div>
            </div>
          </div>

          <div class="_data-card sm">
            <div class="_data-card__logo grey">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.95775 3.14489C6.70561 3.14489 6.46379 3.24505 6.2855 3.42334C6.10721 3.60164 6.00704 3.84345 6.00704 4.09559C6.00704 4.34774 6.10721 4.58955 6.2855 4.76784C6.46379 4.94613 6.70561 5.0463 6.95775 5.0463H8.99722C8.92136 4.85647 8.82897 4.65317 8.71829 4.45194C8.29678 3.68557 7.72965 3.14489 6.95775 3.14489ZM9.26056 6.52517V9.77869H3.97887V7.94911C3.97887 7.55829 3.97945 7.30964 3.99484 7.12126C4.00953 6.94152 4.03393 6.8827 4.04565 6.8597C4.10439 6.74442 4.19812 6.65069 4.3134 6.59195C4.3364 6.58023 4.39523 6.55582 4.57497 6.54114C4.76334 6.52575 5.01199 6.52517 5.40282 6.52517L9.26056 6.52517ZM4.72458 5.05258C4.59621 4.75302 4.52817 4.42781 4.52817 4.09559C4.52817 3.45123 4.78414 2.83326 5.23978 2.37762C5.69541 1.92199 6.31338 1.66602 6.95775 1.66602C8.53741 1.66602 9.48847 2.79448 10 3.71375C10.5115 2.79448 11.4626 1.66602 13.0423 1.66602C13.6866 1.66602 14.3046 1.92199 14.7602 2.37762C15.2159 2.83326 15.4718 3.45123 15.4718 4.09559C15.4718 4.42781 15.4038 4.75302 15.2754 5.05258C15.3711 5.05567 15.4612 5.06029 15.5455 5.06718C15.8167 5.08933 16.0918 5.13861 16.358 5.27426C16.7515 5.47479 17.0715 5.79475 17.272 6.1883C17.4077 6.45454 17.457 6.72964 17.4791 7.00084C17.5 7.25669 17.5 7.56642 17.5 7.92113V13.7912C17.5 14.1459 17.5 14.4556 17.4791 14.7115C17.457 14.9827 17.4077 15.2578 17.272 15.524C17.0715 15.9176 16.7515 16.2375 16.358 16.4381C16.0918 16.5737 15.8167 16.623 15.5455 16.6451C15.2896 16.666 14.9799 16.666 14.6252 16.666H10.0011C10.0007 16.666 10.0004 16.666 10 16.666C9.99963 16.666 9.99927 16.666 9.9989 16.666H5.37483C5.02012 16.666 4.7104 16.666 4.45454 16.6451C4.18334 16.623 3.90824 16.5737 3.64201 16.438C3.24846 16.2375 2.92849 15.9176 2.72797 15.524C2.59232 15.2578 2.54304 14.9827 2.52088 14.7115C2.49997 14.4556 2.49999 14.1459 2.5 13.7912L2.5 10.5185L2.5 7.92115C2.49999 7.56643 2.49997 7.2567 2.52088 7.00084C2.54304 6.72964 2.59232 6.45453 2.72797 6.1883C2.92849 5.79475 3.24846 5.47479 3.64201 5.27426C3.90824 5.13861 4.18334 5.08933 4.45454 5.06717C4.53882 5.06029 4.62894 5.05567 4.72458 5.05258ZM3.97887 11.2576L3.97887 13.7632C3.97887 14.154 3.97945 14.4027 3.99484 14.591C4.00953 14.7708 4.03393 14.8296 4.04565 14.8526C4.10439 14.9679 4.19812 15.0616 4.3134 15.1204C4.3364 15.1321 4.39523 15.1565 4.57497 15.1712C4.76334 15.1866 5.01199 15.1871 5.40282 15.1871H9.26056L9.26056 11.2576H3.97887ZM10.7394 11.2576V15.1871H14.5972C14.988 15.1871 15.2367 15.1866 15.425 15.1712C15.6048 15.1565 15.6636 15.1321 15.6866 15.1204C15.8019 15.0616 15.8956 14.9679 15.9544 14.8526C15.9661 14.8296 15.9905 14.7708 16.0052 14.5911C16.0206 14.4027 16.0211 14.154 16.0211 13.7632V11.2576H10.7394ZM16.0211 9.77869V7.94912C16.0211 7.55829 16.0206 7.30964 16.0052 7.12126C15.9905 6.94152 15.9661 6.8827 15.9544 6.8597C15.8956 6.74442 15.8019 6.65069 15.6866 6.59195C15.6636 6.58023 15.6048 6.55582 15.425 6.54114C15.2367 6.52575 14.988 6.52517 14.5972 6.52517L10.7394 6.52517V9.77869H16.0211ZM13.0423 5.0463C13.2944 5.0463 13.5362 4.94613 13.7145 4.76784C13.8928 4.58955 13.993 4.34774 13.993 4.09559C13.993 3.84345 13.8928 3.60164 13.7145 3.42334C13.5362 3.24505 13.2944 3.14489 13.0423 3.14489C12.2704 3.14489 11.7032 3.68557 11.2817 4.45194C11.171 4.65317 11.0786 4.85647 11.0028 5.0463H13.0423Z"
                  fill="#17B26A"
                />
              </svg>
            </div>
            <div class="_data-card__content" [class.pulse]="!isBrowser">
              <div class="_data-card__content__details">
                <span [translate]="'passport.reward-count-label'"></span>
              </div>
              <div class="_data-card__content__title">
                {{
                  event.tickets[0].cRewards
                    ? ('passport.reward-count-value'
                      | translate : { count: event.tickets[0].cRewards })
                    : ('passport.unlimited-reward' | translate)
                }}
              </div>
            </div>
          </div>
          <div class="_data-card sm">
            <div class="_data-card__logo grey">
              <svg
                width="29"
                height="28"
                viewBox="0 0 29 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.6666 5.36076C9.89531 5.36076 6.02739 9.22868 6.02739 14C6.02739 18.7713 9.89531 22.6392 14.6666 22.6392C19.4379 22.6392 23.3059 18.7713 23.3059 14C23.3059 9.22868 19.4379 5.36076 14.6666 5.36076ZM4.16663 14C4.16663 8.20101 8.86764 3.5 14.6666 3.5C20.4656 3.5 25.1666 8.20101 25.1666 14C25.1666 19.799 20.4656 24.5 14.6666 24.5C8.86764 24.5 4.16663 19.799 4.16663 14ZM14.6666 7.32785C15.1805 7.32785 15.597 7.74439 15.597 8.25823V13.425L18.9106 15.0818C19.3701 15.3116 19.5564 15.8704 19.3266 16.33C19.0968 16.7896 18.538 16.9759 18.0784 16.7461L14.2505 14.8322C13.9354 14.6746 13.7362 14.3524 13.7362 14V8.25823C13.7362 7.74439 14.1528 7.32785 14.6666 7.32785Z"
                  fill="#101828"
                />
              </svg>
            </div>
            <div class="_data-card__content" [class.pulse]="!isBrowser">
              <div class="_data-card__content__details">
                <span [translate]="'passport.end-date-label'"></span>
              </div>
              <div class="_data-card__content__title">
                {{
                  event.end
                    ? ('passport.end-date-value'
                      | translate
                        : { date: (event.end | date : 'MMMM dd, yyyy') })
                    : ('passport.unlimited-date' | translate)
                }}
              </div>
            </div>
          </div>
        </div>

        <ng-template #eventDataCards>
          <div class="_data-card sm">
            <div class="_data-card__logo grey">
              <div class="_day">{{ event.start | date : 'd' }}</div>
              <div class="_month">{{ event.start | date : 'MMM' }}</div>
              <mat-icon class="_icon" svgIcon="custom:events"></mat-icon>
            </div>
            <div class="_data-card__content" [class.pulse]="!isBrowser">
              <div class="_data-card__content__title">
                {{ event.start | date : 'MMMM dd, yyyy' }}
              </div>
              <div class="_data-card__content__details">
                <span [style.opacity]="event.noStartTime ? 0 : 1">
                  {{ event.start | date : 'h:mm a' }}
                </span>

                <ng-container *ngIf="event.end && !event.noEndTime">
                  — Ends {{ event.end | date : 'MMM dd, h:mm a' }}
                </ng-container>
              </div>
            </div>
          </div>
          <div class="_data-card sm" *ngIf="hasEventLocations">
            <div class="_data-card__logo grey">
              <mat-icon svgIcon="custom:location-pin"></mat-icon>
            </div>
            <div class="_data-card__content" [class.pulse]="!isBrowser">
              <div class="_data-card__content__title">
                <ng-container *ngIf="places?.length">
                  <span *ngFor="let place of places; let last = last">{{
                    last ? place.titleWeb : place.titleWeb + ','
                  }}</span>
                </ng-container>
                <span *ngIf="event.locations?.length && places?.length">
                  ,
                </span>
                <ng-container *ngIf="event.locations?.length">
                  <span *ngFor="let place of event.locations; let last = last">
                    {{ last ? place.name : place.name + ',' }}
                  </span>
                </ng-container>
              </div>
              <div class="_data-card__content__details">
                <span *ngFor="let place of places; let last = last">{{
                  last
                    ? place.locationInfo.address
                    : place.locationInfo.address + ','
                }}</span>
                <span *ngIf="event.locations?.length && places?.length">
                  ,
                </span>
                <span *ngFor="let place of event.locations; let last = last">
                  {{
                    last
                      ? place.locationInfo.address
                      : place.locationInfo.address + ','
                  }}
                </span>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
  <div class="_actions" *ngIf="forStandalone">
    <a
      *ngIf="!isPassportMode"
      [routerLink]="standalone ? ['/s/event/', event.slug] : ['./']"
      [queryParams]="{ view: EventView.INFO }"
      [target]="standalone ? '_blank' : '_self'"
    >
      View Event Details
    </a>
    <a
      *ngIf="isPassportMode"
      [routerLink]="standalone ? ['/s/passport/', event.slug] : ['./']"
      [queryParams]="{ view: EventView.INFO }"
      [target]="standalone ? '_blank' : '_self'"
    >
      View Passport Details
    </a>
  </div>
</div>
